<template>
  <div>
    <WhatsappNumberApplication />
  </div>
</template>

<script>
import WhatsappNumberApplication from "../../components/TeamInbox/WhatsappNumberApplication.vue";
export default {
  name: "ApplyNumber",
  components: {
    WhatsappNumberApplication
  }
};
</script>

<style lang="scss" scoped></style>
